module.exports = __webpack_public_path__ + "static/img/COC2021-24.3a12482.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-24.jpg
// module id = 9fMN
// module chunks = 0